import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { DisabledToActiveButton } from '../../misc/Buttons';

import SubsectionInFrame from '../../misc/SubsectionInFrame';

import { trackEvent } from '../../../utils/ga-tracking';

const SearchInstructionsDialog = props => {
  const { type, onAccept, message, continueButtonRef } = props;

  const isBeforeSearchType = type === 'before-search';
  const isBeforeSecondFactorType = type === 'before-second-factor';
  const isAfterSearchType = type === 'after-search';

  const [seconds, setSeconds] = useState(0);
  const timerRef = useRef();

  let buttonLabel = null;
  if (isBeforeSearchType) {
    buttonLabel = (
      <FormattedMessageWrappedInSpan
        id="searchInstructionsDialog.continueSearchButton"
        defaultMessage="Continue to Search"
      />
    );
  } else if (isBeforeSecondFactorType) {
    buttonLabel = (
      <FormattedMessageWrappedInSpan
        id="searchInstructionsDialog.continueValidationButton"
        defaultMessage="Continue to Validation"
      />
    );
  } else if (isAfterSearchType) {
    buttonLabel = (
      <FormattedMessageWrappedInSpan
        id="searchInstructionsDialog.continueSearchResultsButton"
        defaultMessage="Continue to Search Results"
      />
    );
  }

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setSeconds(s => s + 1);
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, []);

  const handleAccept = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    trackEvent('Event', 'Warntext', 'Time dialog was open (in s)', {
      value: seconds,
    });
    onAccept();
  };

  let title = null;
  if (isBeforeSecondFactorType) {
    title = (
      <FormattedMessageWrappedInSpan
        id="searchInstructionsDialog.beforeSecondFactorTitle"
        defaultMessage="Secured Event Instructions"
        className="typography uppercase typography-title_small"
      />
    );
  } else if (isAfterSearchType) {
    title = (
      <FormattedMessageWrappedInSpan
        id="searchInstructionsDialog.afterSearchTitle"
        defaultMessage="Search Results Instructions"
        className="typography uppercase typography-title_small"
      />
    );
  }

  return (
    <SubsectionInFrame
      actionable
      noSidePadding
      center
      title={title}
    >
      <div className="notification-body full-width"
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />
      <DisabledToActiveButton
        className="primary-new subsection-action-button "
        onClick={handleAccept}
        ref={continueButtonRef}
      >
        {buttonLabel}
      </DisabledToActiveButton>
    </SubsectionInFrame>
  );
};

SearchInstructionsDialog.propTypes = {
  message: PropTypes.string,
  onAccept: PropTypes.func,
};

export default SearchInstructionsDialog;
